/* eslint-disable react/require-default-props, no-unused-vars */
import { createTypeElement, createPropTypes } from './util'

const MindfulText = ({ as = 'div', ...props }) =>
  createTypeElement('MindfulText', { as, ...props })

MindfulText.propTypes = createPropTypes()

export default MindfulText
